// ============================================================================
// ARABIC TRANSLATIONS - CHAPTER 8: عون العلي (مكافأة)
// ============================================================================
// المستوى 92 (مستوى مكافأة واحد، 3 أسئلة)

export const chapter8Translations = {
  name: "عون العلي",
  description: "الساكن في ستر العلي، في ظل القدير يبيت",
  
  spiritualWisdom: {
    principle: "لقد وصلت إلى قمة الجبل، والمعرفة قد تم اكتسابها",
    scripture: "الساكن في ستر العلي، في ظل القدير يبيت (مزمور 91:1)",
    application: "الإيمان الثابت يتطلب خبرة حياتية، ورحمة، ومحبة يسوع الحقيقية. ستختبر التجارب قلبك، الطريق الحقيقي الذي اخترته."
  },
  
  levels: {
    92: {
      name: "ستر العلي",
      challenge: "أنت على قمة الجبل... لكن الإيمان الثابت يبدأ الآن...",
      easy: {
        question: "من هو يسوع بالنسبة لك شخصياً؟",
        options: [
          "نبي بسيط",
          "ربي ومخلصي الشخصي",
          "أسطورة",
          "فيلسوف"
        ],
        hint: "هو الذي يعطي حياته لينقذنا",
        funFact: "✝️ يسوع هو الله! إنه ليس مجرد شخصية تاريخية - إنه حي ويرغب في علاقة شخصية مع كل واحد منا!"
      },
      medium: {
        question: "لماذا الصوم كما فعل دانيال يسمح لنا بسماع الله بشكل أفضل؟",
        options: [
          "لفقدان الوزن",
          "لحرمان أنفسنا مما نحب ولنحصل على قلب متحول",
          "لإثارة إعجاب الآخرين",
          "لنكون أقوى"
        ],
        hint: "احرم نفسك مما تحبه أكثر، في الهدوء والحكمة",
        funFact: "🙏 الصوم الروحي يعد قلوبنا للتحولات العميقة - غالباً مؤلمة - التي تقربنا من الله!"
      },
      hard: {
        question: "ما هي الاستجابة الحقيقية للقلب أمام كل هذه المعرفة المكتسبة؟",
        options: [
          "أنا الآن مثالي",
          "أعطيك قلبي يا يسوع وأرغب في أن أعتمد",
          "أعرف أفضل من الآخرين",
          "لم أعد بحاجة إلى مساعدة"
        ],
        hint: "الإيمان الحقيقي يؤدي إلى الاستسلام الكامل والالتزام بيسوع",
        funFact: "🌟✨ لقد وصلت إلى قمة الجبل، والمعرفة قد تم اكتسابها ✨\n\n💖 الإيمان الثابت يتطلب خبرة حياتية، ورحمة، ومحبة يسوع الحقيقية 💖\n\n🔥 التجارب المختلفة في الحياة ستختبر طريقك، المسار الحقيقي الذي نختاره، قلبنا 🔥\n\n😔 نبقى غير كاملين، رغباتنا كثيرة، ومحبة الربح أو راحتنا الشخصية تصبح في كثير من الأحيان أولويتنا الأنانية 😔\n\n🙏 اطلب من الله الحكمة، محبته، قوته، واعترف بضعفاتك بتواضع، لأننا لا نستطيع إخفاء أي شيء عنه... أي شيء 🙏\n\n🥖 صم كما فعل دانيال: احرم نفسك لفترة مما تحبه أكثر، في الهدوء والحكمة 🥖\n\n💫 سيسمح لك ذلك بسماع الله بشكل أفضل، وأن يكون لديك استعداد قلب جاهز للتحولات العميقة 💫\n\n🌙 عندها، ستصبح الأحلام والرؤى أكثر وضوحاً، كما حدث ليوسف 🌙\n\n⚠️ احذر من الكبرياء: لا تستسلم لـ 'أنا دائماً على حق' أو 'أعرف أفضل' ⚠️\n\n🎁 لأن إعلان الله هو نعمة استثنائية 🎁\n\n💝 أن يكون لديك إيمان يعني الدخول في علاقة ومسار حر للقلب 💝\n\n🦸‍♂️ سيجعلك أبطالاً أقوياء، قادرين على المستحيل 🦸‍♂️\n\n✝️ في قمة المعرفة، يقول القلب الصادق: 'أعطيك قلبي يا يسوع وأرغب في أن أعتمد' ✝️\n\n🏔️ لقد وصلت إلى قمة الجبل، تمسك بقوة، ثابر! 🏔️\n\n⬇️ يجب أن تنزل وتحمل هذا الكنز الثمين: رجاء الحياة الأبدية ⬇️\n\n🏆✨ برافو! نحن فخورون بك ✨🏆\n🌟 شجاعة أيها الحامل الشجاع للسلام 🌟\n🕊️✨ بارك الله فيك ✨🕊️"
      }
    }
  }
};

export default chapter8Translations;
